export default {
	name: 'ProductsContainer'
}